import getConstants from '../../constants'

const constants = getConstants()
const brand = constants.BRAND.toLowerCase()

export const extractTranslations = async (
  country: string,
  language: string,
): Promise<{ [key: string]: string }> => {
  let countryCode = country.toUpperCase()

  if (/^[\w-]{5}/.exec(country)) {
    countryCode = 'EU'
  }

  // * Logic must be inside import using string template, else the import wont work in time
  const translations = await import(
    `excel-to-json-test/translations/${brand}/js/${brand}-${language}-${countryCode}`
  )
  return translations
}
